<ion-card>
  <ion-card-header>
    <ion-card-title>Érkeztetés</ion-card-title>
    <ion-card-subtitle>
      A beérkezett küldemények iktatás előtt. Papír, e-mail és BKSZ (hivatali kapu,
      cégkapu) egyaránt ide kerül; innen egy kattintással iktatható.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="ikt-fejsor">
      <ion-input label="Év" label-placement="stacked" type="number" [(ngModel)]="ev"
                 (ionBlur)="betolt()" style="max-width:110px"></ion-input>
      <ion-checkbox labelPlacement="end" [checked]="csakNyitott"
                    (ionChange)="csakNyitott = $event.detail.checked; betolt()">
        Csak a még nem iktatottak
      </ion-checkbox>
      <ion-button size="small" (click)="ujForm = !ujForm">
        <ion-icon slot="start" name="add-outline"></ion-icon>Új érkeztetés
      </ion-button>
      <ion-button size="small" fill="outline" (click)="hivataliNyitva = !hivataliNyitva">
        <ion-icon slot="start" name="cloud-download-outline"></ion-icon>BKSZ behúzás
      </ion-button>
    </div>

    <!-- BKSZ behúzás: a hivatali kapu postafiókja a BKSZ gépi interfészén -->
    <div class="ikt-fejsor" *ngIf="hivataliNyitva">
      <ion-button size="small" (click)="hivataliKapu()" [disabled]="hivataliFolyamatban">
        <ion-icon slot="start" name="cloud-download-outline"></ion-icon>
        {{ hivataliFolyamatban ? (hivataliAllapot || 'Letöltés…') : 'Letöltés most' }}
      </ion-button>
      <ion-button size="small" fill="clear" routerLink="/iktatgato/bksz">Ütemezés és letöltött tételek</ion-button>
      <ion-note color="medium" style="flex:1 1 100%;font-size:.78rem">
        A hivatali kapu postafiókját a BKSZ-kapcsolaton töltjük le: a küldemények érkeztetve, a fájlokkal
        együtt kerülnek ide, az igazolások a kiküldött tételhez. A letöltött tétel csak a sikeres tárolás
        után törlődik a postafiókból, ezért a lekérés bármikor megismételhető – nem érkeztet duplán.
      </ion-note>
    </div>

    <!-- ÉRKEZTETŐ LAP -->
    <div *ngIf="ujForm" class="ikt-lap-doboz">
      <!-- Állapotjelölők -->
      <div class="ikt-jelolok">
        <span class="ikt-jelolo" [class.aktiv]="uj.digitalis"
              (click)="uj.digitalis = !uj.digitalis">Digitális</span>
        <span class="ikt-jelolo piros" [class.aktiv]="uj.nem_iktatando"
              (click)="uj.nem_iktatando = !uj.nem_iktatando">Nem iktatandó</span>
        <span class="ikt-jelolo piros" [class.aktiv]="uj.serult"
              (click)="uj.serult = !uj.serult">Sérült</span>
        <span class="ikt-jelolo" [class.aktiv]="uj.elektronikus_visszaigazolas"
              (click)="uj.elektronikus_visszaigazolas = !uj.elektronikus_visszaigazolas">
          Elektronikus visszaigazolás
        </span>
        <span class="ikt-jelolo" [class.aktiv]="uj.felbontatlan"
              (click)="uj.felbontatlan = !uj.felbontatlan">Felbontatlan</span>
        <span class="ikt-jelolo" [class.aktiv]="uj.sk_felbontas"
              (click)="uj.sk_felbontas = !uj.sk_felbontas">S. k. felbontású</span>
      </div>

      <ion-segment [(ngModel)]="ful" mode="ios">
        <ion-segment-button value="kuldemeny"><ion-label>Küldemény adatok</ion-label></ion-segment-button>
        <ion-segment-button value="kulcsszavak"><ion-label>Kulcsszavak, feljegyzés</ion-label></ion-segment-button>
      </ion-segment>

      <ng-container *ngIf="ful === 'kuldemeny'">
        <div class="ikt-oszlopok">
          <!-- Bal: beérkezés, beküldő, címzett -->
          <div>
            <h4>Beérkezés adatok</h4>
            <div class="ikt-mezosor">
              <ion-select label="Beérkezés módja" label-placement="stacked" interface="popover"
                          [(ngModel)]="uj.erkezes_mod" (ionChange)="modValt()">
                <ion-select-option *ngFor="let m of MODOK" [value]="m.kulcs">{{ m.nev }}</ion-select-option>
              </ion-select>
              <ion-select label="Adathordozó" label-placement="stacked" interface="popover"
                          [(ngModel)]="uj.adathordozo">
                <ion-select-option value="papir">papír</ion-select-option>
                <ion-select-option value="elektronikus">elektronikus</ion-select-option>
                <ion-select-option value="vegyes">vegyes</ion-select-option>
              </ion-select>
              <ion-input label="Küldemény azonosítója" label-placement="stacked"
                         [(ngModel)]="uj.azonosito"></ion-input>
            </div>

            <h4>Beküldő adatai</h4>
            <div class="ikt-mezosor">
              <ion-select label="Beküldő szervezet" label-placement="stacked" interface="popover"
                          [(ngModel)]="uj.bekuldo_szervezet" (ionChange)="bekuldoValt()">
                <ion-select-option value="">– nincs –</ion-select-option>
                <ion-select-option *ngFor="let p of szervezetek" [value]="p.id">{{ p.nev }}</ion-select-option>
              </ion-select>
              <ion-select label="Beküldő személy" label-placement="stacked" interface="popover"
                          [(ngModel)]="uj.bekuldo_szemely" (ionChange)="bekuldoValt()">
                <ion-select-option value="">– nincs –</ion-select-option>
                <ion-select-option *ngFor="let p of szemelyek" [value]="p.id">{{ p.nev }}</ion-select-option>
              </ion-select>
              <ion-input label="Beküldő neve (szabadon)" label-placement="stacked"
                         [(ngModel)]="uj.kuldo_nev"></ion-input>
              <ion-input label="Beküldő címe" label-placement="stacked" [(ngModel)]="uj.kuldo_cim"></ion-input>
              <ion-input label="Beküldő e-mail címe" label-placement="stacked" type="email"
                         [(ngModel)]="uj.bekuldo_email"></ion-input>
            </div>

            <h4>Címzett</h4>
            <div class="ikt-mezosor">
              <ion-select label="Eredeti címzett szervezet" label-placement="stacked" interface="popover"
                          [(ngModel)]="uj.cimzett_szervezet">
                <ion-select-option value="">– nincs –</ion-select-option>
                <ion-select-option *ngFor="let p of szervezetek" [value]="p.id">{{ p.nev }}</ion-select-option>
              </ion-select>
              <ion-checkbox labelPlacement="end" [checked]="uj.csak_belso_szemelyek"
                            (ionChange)="uj.csak_belso_szemelyek = $event.detail.checked">
                Csak belső személyek
              </ion-checkbox>
              <ion-select label="Eredeti címzett személy" label-placement="stacked" interface="popover"
                          [(ngModel)]="uj.cimzett_szemely">
                <ion-select-option value="">– nincs –</ion-select-option>
                <ion-select-option *ngFor="let p of szemelyek"
                                   [value]="p.id" [disabled]="uj.csak_belso_szemelyek && !p.belso">
                  {{ p.nev }}
                </ion-select-option>
              </ion-select>
              <ion-select label="Belső címzett szervezet" label-placement="stacked" interface="popover"
                          [(ngModel)]="uj.belso_cimzett_szervezet">
                <ion-select-option value="">– nincs –</ion-select-option>
                <ion-select-option *ngFor="let p of szervezetek" [value]="p.id">{{ p.nev }}</ion-select-option>
              </ion-select>
            </div>
          </div>

          <!-- Jobb: alapadatok -->
          <div>
            <h4>Alapadatok</h4>
            <div class="ikt-mezosor">
              <ion-select label="Érkeztető könyv" label-placement="stacked" interface="popover"
                          [(ngModel)]="uj.erkezteto_konyv">
                <ion-select-option value="sajat">saját</ion-select-option>
                <ion-select-option value="kozponti">központi</ion-select-option>
              </ion-select>
              <ion-select label="Kézbesítés prioritása" label-placement="stacked" interface="popover"
                          [(ngModel)]="uj.prioritas">
                <ion-select-option value="">– nincs –</ion-select-option>
                <ion-select-option *ngFor="let p of PRIORITASOK" [value]="p">{{ p }}</ion-select-option>
              </ion-select>
              <ion-input label="Feladás ideje" label-placement="stacked" type="datetime-local"
                         [(ngModel)]="uj.feladas_ideje"></ion-input>
              <ion-input label="Beérkezés ideje" label-placement="stacked" type="date"
                         [(ngModel)]="uj.erkezett"></ion-input>
              <ion-input label="Tárgy" label-placement="stacked" [(ngModel)]="uj.targy"></ion-input>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="ful === 'kulcsszavak'">
        <div class="ikt-mezosor">
          <ion-input label="Kulcsszavak (vesszővel)" label-placement="stacked"
                     [(ngModel)]="uj.kulcsszavak" style="flex:1 1 100%;max-width:100%"></ion-input>
        </div>
        <ion-textarea label="Feljegyzés" label-placement="stacked" rows="3" [autoGrow]="true"
                      [(ngModel)]="uj.feljegyzes"></ion-textarea>
        <ion-textarea label="Megjegyzés" label-placement="stacked" rows="2" [autoGrow]="true"
                      [(ngModel)]="uj.megjegyzes"></ion-textarea>
      </ng-container>

      <div class="ikt-gombsor">
        <ion-button size="small" (click)="rogzit()">
          <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
        </ion-button>
        <ion-button size="small" fill="clear" (click)="ujForm = false">Mégse</ion-button>
      </div>
    </div>

    <div *ngIf="betoltes" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>

    <div class="ikt-tabla-doboz" *ngIf="!betoltes">
      <table class="ikt-tabla">
        <thead>
          <tr>
            <th class="szam">Sorszám</th><th>Érkezett</th><th>Mód</th><th>Beküldő</th>
            <th>Tárgy</th><th>Jelölők</th><th>Állapot</th><th>Művelet</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of sorok">
            <td class="szam">{{ s.sorszam }}/{{ s.ev }}</td>
            <td class="szam">{{ s.erkezett }}</td>
            <td>{{ s.erkezes_mod }}</td>
            <td>{{ s.kuldo_nev }}</td>
            <td>{{ s.targy }}</td>
            <td>
              <ion-badge color="tertiary" *ngIf="s.digitalis">digitális</ion-badge>
              <ion-badge color="danger" *ngIf="s.serult">sérült</ion-badge>
              <ion-badge color="medium" *ngIf="s.nem_iktatando">nem iktatandó</ion-badge>
              <ion-badge color="warning" *ngIf="s.prioritas">{{ s.prioritas }}</ion-badge>
            </td>
            <td>
              <ion-badge [color]="s.iktatva ? 'success' : 'warning'">
                {{ s.iktatva ? 'iktatva' : 'iktatásra vár' }}
              </ion-badge>
            </td>
            <td>
              <ion-button size="small" fill="clear" *ngIf="!s.iktatva" (click)="iktat(s)">Iktatás</ion-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ikt-ures" *ngIf="!sorok.length">Nincs megjeleníthető érkeztetés.</div>
    </div>
  </ion-card-content>
</ion-card>
